import { SelectOption } from '@teachstonellc/component-library';
import { AgeLevel } from 'types/api/envScales/AgeLevel';

export function getDimensions(ageLevel: AgeLevel) {
  return ageLevel.domains.flatMap(domain => domain.dimensions);
}

export function getDimension(ageLevel: AgeLevel, dimensionId: number | null) {
  if (dimensionId === null) {
    return undefined;
  }

  return getDimensions(ageLevel).find(
    dimension => dimension.id === dimensionId
  );
}

export function getIndicator(
  ageLevel: AgeLevel,
  dimensionId: number | null,
  indicatorId: number | null
) {
  if (indicatorId === null) {
    return undefined;
  }

  return getDimension(ageLevel, dimensionId)?.indicators?.find(
    indicator => indicator.id === indicatorId
  );
}

/**
 * Suggestions only exist for formal observations. Callers pass a `null`
 * suggested id for informal, so nothing is ever marked.
 */
function withSuggestedLabel(
  name: string,
  id: number,
  suggestedId: number | null,
  suggestedLabel: string
) {
  return id === suggestedId ? `${name} ${suggestedLabel}` : name;
}

export function getDimensionOptions(
  ageLevel: AgeLevel,
  suggestedDimensionId: number | null,
  suggestedLabel: string
): SelectOption[] {
  return getDimensions(ageLevel).map(dimension => ({
    value: dimension.id,
    text: withSuggestedLabel(
      dimension.name,
      dimension.id,
      suggestedDimensionId,
      suggestedLabel
    )
  }));
}

export function getIndicatorOptions(
  ageLevel: AgeLevel,
  dimensionId: number | null,
  suggestedIndicatorId: number | null,
  suggestedLabel: string
): SelectOption[] {
  const dimension = getDimension(ageLevel, dimensionId);

  if (!dimension) {
    return [];
  }

  return dimension.indicators.map(indicator => ({
    value: indicator.id,
    text: withSuggestedLabel(
      indicator.name,
      indicator.id,
      suggestedIndicatorId,
      suggestedLabel
    )
  }));
}

export function getFirstIndicator(
  ageLevel: AgeLevel,
  dimensionId: number | null
) {
  return getDimension(ageLevel, dimensionId)?.indicators?.[0] ?? null;
}
